import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

export function DangerPage() {
  const t = useT()
  const navigate = useNavigate()
  const [confirm, setConfirm] = useState('')

  const cancel = useMutation({
    mutationFn: () => apiClient.delete('/tenants/current'),
    onSuccess: () => {
      localStorage.removeItem('discover.jwt')
      navigate('/auth/signin?cancelled=ok')
    },
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-1">{t('settings.danger.title')}</h1>
      <p className="text-sm opacity-70 mb-6">{t('settings.danger.subtitle')}</p>

      <section
        className="p-4 rounded border"
        style={{ borderColor: 'var(--color-critical)' }}
      >
        <h2 className="text-sm font-medium" style={{ color: 'var(--color-critical)' }}>
          {t('settings.danger.cancel.title')}
        </h2>
        <p className="text-xs opacity-80 mt-1 mb-3">{t('settings.danger.cancel.body')}</p>
        <label className="block text-xs mb-2">
          {t('settings.danger.cancel.confirm_label', { word: 'DELETE' })}
          <input
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="auth-input mt-1"
          />
        </label>
        <button
          type="button"
          disabled={confirm !== 'DELETE' || cancel.isPending}
          onClick={() => cancel.mutate()}
          className="px-3 py-1.5 text-sm rounded font-medium"
          style={{ background: confirm === 'DELETE' ? 'var(--color-critical)' : 'transparent', color: confirm === 'DELETE' ? 'white' : 'var(--color-muted)', border: '1px solid var(--color-critical)' }}
        >
          {t('settings.danger.cancel.cta')}
        </button>
      </section>
    </div>
  )
}
